// extracted by mini-css-extract-plugin
export default {"event-type-option":"EventTypeSelect_event-type-option__ox961","type-square":"EventTypeSelect_type-square__CBv1T"};